import React from 'react';

import getFormatedDate from '@functions/getFormatedDate.ts';
import ReferralProcessItemT from '@global/models/ReferralProcessItem.ts';

import { RenderColsT } from '../../types.ts';

const renderReferralProcessItems: RenderColsT<'referralProcessItems'> = function ({
    name: colName,
    item,
}) {
    let content;
    let className;
    const referralProcessItem = item as ReferralProcessItemT;

    if (colName === 'detail') {
        content = <div className="v2table__text">{referralProcessItem.detail || '–'}</div>;
    }

    if (colName === 'date') {
        content = (
            <div className="v2table__text">
                {getFormatedDate({
                    date: new Date(referralProcessItem.cDate),
                    isShortYear: true,
                    type: 'full',
                })}
            </div>
        );
    }

    return { content, className };
};

export default renderReferralProcessItems;
